import { useState, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import type { WorkerListParams } from 'api/workers/types'

import { ENABLE_DIALOG_ERROR_STATUS_CODES } from 'slices/utils'
import { deleteWorker, selectWorkersStatus } from 'slices/workersSlice'

import { CustomModal } from 'components/common'

type Props = {
  isOpen: boolean
  workerId: number
  workerListParams?: WorkerListParams
  onSuccess: () => void
  onCancel: () => void
}

const WorkerDelete = ({ isOpen, workerId, workerListParams, onSuccess, onCancel }: Props) => {
  const [modalErrorMessage, setModalErrorMessage] = useState<string | undefined>(undefined)
  const [submitted, setSubmitted] = useState(false)
  const { isRequesting, errorMessage } = useSelector(selectWorkersStatus, shallowEqual)
  const dispatch = useDispatch()

  const handleCancelClick = () => {
    setModalErrorMessage(undefined)
    setSubmitted(false)
    onCancel()
  }

  useEffect(() => {
    if (!submitted || isRequesting) {
      return
    }
    if (errorMessage === '') {
      onSuccess()
    } else if (!ENABLE_DIALOG_ERROR_STATUS_CODES.includes(errorMessage)) {
      setModalErrorMessage('削除できませんでした。')
    }
    setSubmitted(false)
  }, [onSuccess, submitted, isRequesting, errorMessage, dispatch])

  const handleDeleteClick = () => {
    setSubmitted(true)
    dispatch(deleteWorker(workerId, workerListParams))
  }

  return (
    <CustomModal
      isOpen={isOpen}
      title="メンバーの削除"
      approveColor="danger"
      approveLabel="削除"
      errorMessage={modalErrorMessage}
      onCancel={handleCancelClick}
      onApprove={handleDeleteClick}
      onHideNotification={() => setModalErrorMessage(undefined)}
    >
      <div className="pb-4">このメンバーを本当に削除しますか？この操作は取り消せません。</div>
    </CustomModal>
  )
}

export default WorkerDelete
